/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface ConfigurationSchemaResponse
 */
export interface ConfigurationSchemaResponse extends Status {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationSchemaResponse
     */
    schema: string;
    /**
     * 
     * @type {Status}
     * @memberof ConfigurationSchemaResponse
     */
    verificationStatus?: Status;
}

/**
 * Check if a given object implements the ConfigurationSchemaResponse interface.
 */
export function instanceOfConfigurationSchemaResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "schema" in value;

    return isInstance;
}

export function ConfigurationSchemaResponseFromJSON(json: any): ConfigurationSchemaResponse {
    return ConfigurationSchemaResponseFromJSONTyped(json, false);
}

export function ConfigurationSchemaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationSchemaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'schema': json['schema'],
        'verificationStatus': !exists(json, 'verificationStatus') ? undefined : StatusFromJSON(json['verificationStatus']),
    };
}

export function ConfigurationSchemaResponseToJSON(value?: ConfigurationSchemaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'schema': value.schema,
        'verificationStatus': StatusToJSON(value.verificationStatus),
    };
}

